export const generateWidgetUrl = (
  backgroundColor?: string,
  messageColor?: string,
  nameColor?: string,
  scale?: string,
  broadcastId?: string,
  chatToken?: string
) => {
  return `${window.location.origin}/widget?background_color=${backgroundColor}&message_color=${messageColor}&name_color=${nameColor}&scale=${scale}&id=${broadcastId}&chat_token=${chatToken}`;
};